import React from 'react';
import { useTranslation } from 'react-i18next';

import FormDrawer from '~/components/FormDrawer';
import { useMutateContactsApi } from '~/controllers/contacts';
import { ApplicationPayload } from '~/types/ApplicationPayload';
import { FormItemInjectedProps } from '~/types/FormItemInjectedProps';
import { IndividualRowType } from '~/types/IndividualRowType';
import { Person } from '~/types/Person';
import buildNamePath from '~/utils/buildNamePath';

import AuthorizedRepresentativeForm from './AuthorizedRepresentativeForm';

interface Props extends Partial<FormItemInjectedProps<Person[]>> {
  uid: string;
  onClose: () => void;
  setSourceOfEditing: (value: string) => void;
  authorizedRepresentativesDataSource: Person | IndividualRowType[];
}

const AuthorizedRepresentativeEdit: React.FC<Props> = (props) => {
  const { uid, onClose, authorizedRepresentativesDataSource, setSourceOfEditing } = props;
  const { value, onChange } = props as FormItemInjectedProps<Person[]>;
  const { t } = useTranslation('fillApplication');
  const contactsMutation = useMutateContactsApi();

  const currentIndex = value.length ? value?.findIndex((item) => item?.uid === uid) : 0;
  const onFinish = (newValues: ApplicationPayload | any) => {
    const updatedIndividual = newValues?.authorizedRepresentative[currentIndex];
    const authorizedRepresentativeFormState = [...value];
    authorizedRepresentativeFormState?.splice(currentIndex, 1, updatedIndividual);
    contactsMutation.mutate(updatedIndividual);
    onChange(authorizedRepresentativeFormState);
    setSourceOfEditing('authorizedRepresentative');
    onClose();
  };

  return (
    <FormDrawer
      id="authorizedRepresentativeEditDrawer"
      open={!!uid}
      onClose={onClose}
      title={t('Edit Authorized Representative')}
      formName="addNewAuthorizedRepresentative"
    >
      <AuthorizedRepresentativeForm
        onFinish={onFinish}
        n={buildNamePath(['authorizedRepresentative', currentIndex])}
        initialValues={authorizedRepresentativesDataSource}
      />
    </FormDrawer>
  );
};

export default AuthorizedRepresentativeEdit;
